import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Building2, Mail, Phone, MapPin } from "lucide-react";

const Impressum = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <Badge className="bg-gray-100 text-gray-800">Impressum</Badge>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Impressum
          </h1>
          <p className="text-lg text-gray-600">
            Angaben gemäß § 5 TMG
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center">
                <Building2 className="mr-2 h-5 w-5" />
                Unternehmen
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-4">NetSyTe - Netzwerk System Technik</h2>
                
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-2">Geschäftsführer:</h3>
                    <p className="text-gray-600">[Ihr vollständiger Name]</p>
                  </div>
                  
                  <div>
                    <h3 className="font-semibold text-gray-700 mb-2">Rechtsform:</h3>
                    <p className="text-gray-600">[z.B. Einzelunternehmen / GmbH / UG]</p>
                  </div>
                </div>

                <div className="mt-6">
                  <h3 className="font-semibold text-gray-700 mb-2">Handelsregister:</h3>
                  <p className="text-gray-600">
                    [Falls eingetragen: Registergericht und Handelsregisternummer]<br />
                    <span className="text-sm">(Nur bei eingetragenen Unternehmen erforderlich)</span>
                  </p>
                </div>

                <div className="mt-6">
                  <h3 className="font-semibold text-gray-700 mb-2">Umsatzsteuer-ID:</h3>
                  <p className="text-gray-600">
                    [Ihre USt-IdNr. nach §27a UStG]<br />
                    <span className="text-sm">(Falls vorhanden)</span>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center">
                <MapPin className="mr-2 h-5 w-5" />
                Anschrift
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-800">
                  [Straße und Hausnummer]<br />
                  [PLZ und Ort]<br />
                  Deutschland
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Kontakt</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-blue-600" />
                  <div>
                    <p className="font-semibold">Telefon</p>
                    <p className="text-gray-600">+49 (0) 123 456 7890</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-blue-600" />
                  <div>
                    <p className="font-semibold">E-Mail</p>
                    <p className="text-gray-600">info@netsyte.de</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Berufsbezeichnung und berufsrechtliche Regelungen</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600">
                <strong>Berufsbezeichnung:</strong> IT-Dienstleister / Systemadministrator<br />
                <span className="text-sm">(Falls zutreffend, z.B. bei reglementierten Berufen)</span>
              </p>
              
              <p className="text-gray-600">
                <strong>Zuständige Kammer:</strong><br />
                <span className="text-sm">
                  [Falls Mitglied in einer Kammer, z.B. IHK]<br />
                  (Nur bei kammerpflichtigen Berufen erforderlich)
                </span>
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-800">
                  [Ihr vollständiger Name]<br />
                  [Straße und Hausnummer]<br />
                  [PLZ und Ort]<br />
                  Deutschland
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Haftungsausschluss</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Haftung für Inhalte</h3>
                <p className="text-gray-600 text-sm">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte 
                  fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                  rechtswidrige Tätigkeit hinweisen.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Haftung für Links</h3>
                <p className="text-gray-600 text-sm">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                  keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                  Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                  Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-gray-700 mb-2">Urheberrecht</h3>
                <p className="text-gray-600 text-sm">
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                  unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                  Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                  bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>EU-Streitschlichtung</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p className="text-gray-600 text-sm">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" 
                   className="text-blue-600 hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              
              <p className="text-gray-600 text-sm">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <div className="mt-6">
                <h3 className="font-semibold text-gray-700 mb-2">Verbraucherstreitbeilegung</h3>
                <p className="text-gray-600 text-sm">
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </CardContent>
          </Card>

          <div className="text-center pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              <strong>Hinweis:</strong> Bitte ersetzen Sie alle Platzhalter in eckigen Klammern [...] 
              mit Ihren echten Unternehmensdaten.
            </p>
            <p className="text-xs text-gray-400 mt-2">
              Stand: Dezember 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;